export const getOrientation = (width: number, height: number) => {
  if (width > height) return 'landscape';
  if (width < height) return 'portrait';
  return 'even';
};
